import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ITema } from 'modelos/src';
import { TemaRuntimeService } from './auxiliares/servicios/tema-runtime.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: false,
})
export class AppComponent implements OnInit {
  temaRuntime = inject(TemaRuntimeService);

  public tema$: Observable<ITema | null>;

  constructor() {
    this.tema$ = this.temaRuntime.tema$;
  }

  async ngOnInit() {
    await this.temaRuntime.init();
  }
}
